import { createStore } from 'vuex'

export default createStore({
  state: {
    target_vendor:{}
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
